
<div [class]="'c-add-manual-item__section '+stepStatus">

  <!--section header-->
  <div class="c-add-manual-item__section-header">
            <span class="c-add-manual-item__section-number">
                <svg class="a-icon c-add-manual-item__header-icon">
                   <use xlink:href="#tick"></use>
                </svg>
                1
            </span>
    <div class="c-add-manual-item__section-title">
      <h4 class="t3 ts-normal">Grab your flight</h4>
      <span class="s6-text tc-muted">You can choose between grab with prices or grab itinerary and add prices manually</span>
    </div>
    <button class="a-link-btn a-link-btn--primary c-add-manual-item__section-edit" (click)="backToStep()" *ngIf="!isRefine">
      <svg class="a-icon u-rmr u-x1.25">
        <use xlink:href="#edit"></use>
      </svg>
      Edit
    </button>
  </div>

  <div class="c-add-manual-item__section-summary" *ngIf="stepStatus === MODAL_STEP.isDone || isRefine">
    <div class="c-add-manual-item__info-block">

      <ng-container *ngIf="isGrabWithPrice">
        <span class="t-4 u-mb-t">{{grabWithPrice}}</span>
        <span class="s tc-muted">{{grabWithPriceDetail}}</span>
      </ng-container>
      <ng-container *ngIf="!isGrabWithPrice">
        <span class="t-4 u-mb-t">{{grabWithOutPrice}}</span>
        <span class="s tc-muted">{{grabWithOutPriceDetail}}</span>
      </ng-container>
    </div>
  </div>

  <div class="c-add-manual-item__section__content" *ngIf="stepStatus === MODAL_STEP.isActive">

    <div class="c-add-manual-item__form">

      <div class="o-inline-form-group c-add-manual-item__form-group">

        <div *ngIf="enableRadioButtonGrabWithPrice" id="grabWithPriceID" class="o-inline-form-group__item c-add-manual-item__form-item" (click)="GrabWithPrice()">
          <label [ngClass]="[isGrabWithPrice ? 'c-passenger-form__option '+'is-selected' : 'c-passenger-form__option']">
            <label class="a-radio c-passenger-form__option-btn">
              <input type="radio" class="a-radio__check" value="None" name="pay" [checked]="isGrabWithPrice">
              <span class="a-radio__label">{{grabWithPrice}}</span>
            </label>
            <span class="c-passenger-form__option-txt">{{grabWithPriceDetail}}</span>
          </label>
        </div>

        <div *ngIf="!isDP && enableRadioButtonGrabWithOutPrice" id="grabWithOutPriceID" class="o-inline-form-group__item c-add-manual-item__form-item" (click)="GrabWithOutPrice()">
          <label [ngClass]="[(!isGrabWithPrice) ? 'c-passenger-form__option '+'is-selected' : 'c-passenger-form__option']">
            <label class="a-radio c-passenger-form__option-btn">
              <input type="radio" class="a-radio__check" value="None" name="pay" [checked]="!isGrabWithPrice">
              <span class="a-radio__label">{{grabWithOutPrice}}</span>
            </label>
            <span class="c-passenger-form__option-txt">{{grabWithOutPriceDetail}}</span>
          </label>
        </div>
        <div *ngIf="(!(enableRadioButtonGrabWithPrice && enableRadioButtonGrabWithOutPrice)) || isDP" class="o-inline-form-group__item c-add-manual-item__form-item"></div>
      </div>

    </div>

    <div class="c-add-manual-item__btn-section">
      <button class="a-btn a-btn--primary" id="grabFltPriceSelContinueID" (click)="completeStep()">Continue</button>
    </div>

  </div>

</div>
